import endOfDays from './endOfDays';

export default endOfDays;
